import { buildInterviewIso } from 'features/sendouts/common/utils';
import { EMAIL_DETAILS_FORM_FIELDS_MAP } from 'features/sendouts/components/forms/EmailDetails/EmailDetails.fields';
import omit from 'lodash/omit';

import {
  buildAttachments,
  buildEmailList,
  buildLegacyInterviews,
  buildNumberValue,
  mapCancelEmailToSendEmail
} from './SendoutForm.utils';

export const SENDOUT_TEMPLATE_ID = 3;

export const FORM_FIELDS_MAP = {
  ...EMAIL_DETAILS_FORM_FIELDS_MAP,
  AccountableRecruiter: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.AccountableRecruiter,
    paramKey: 'job_order_accountable_id',
    outboundAccesor: 'id'
  },
  Candidate: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.Candidate,
    paramKey: 'candidate_id',
    outboundAccesor: 'id'
  },
  CandidateRecruiter: {
    key: 'candidateRecruiter',
    paramKey: 'candidate_accountable_id',
    outboundAccesor: 'id'
  },
  EstimatedFeeAmount: {
    key: 'estimatedFeeAmount',
    paramKey: 'fee_amount',
    outboundAccesor: buildNumberValue
  },
  InterviewType: {
    key: 'interviewType'
  },
  InterviewDate: {
    key: 'interviewDate'
  },
  InterviewTimeFrame: {
    key: 'interviewTimeFrame'
  },
  InterviewFromHour: {
    key: 'interviewFromHour',
    outboundAccesor: buildInterviewIso
  },
  InterviewToHour: {
    key: 'interviewToHour',
    outboundAccesor: buildInterviewIso
  },
  InterviewAddress: {
    key: 'interviewAddress'
  },
  InterviewLink: {
    key: 'interviewLink'
  },
  InterviewTimezone: {
    key: 'interviewTimezone',
    outboundAccesor: 'momentName'
  },
  CandidateTwentyFourHoursReminder: {
    key: 'candidateTwentyFourHoursReminder'
  },
  HiringAuthorityTwentyFourHoursReminder: {
    key: 'hiringAuthorityTwentyFourHoursReminder'
  },
  CandidateOneHourReminder: {
    key: 'candidateOneHourReminder'
  },
  HiringAuthorityOneHourReminder: {
    key: 'hiringAuthorityOneHourReminder'
  },
  HiringAuthority: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.HiringAuthority,
    paramKey: 'hiring_authority'
  },
  CancelEmailToHiringAuthority: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.CancelEmailToHiringAuthority,
    paramKey: 'send_email',
    outboundAccesor: mapCancelEmailToSendEmail
  },
  CarbonCopy: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.CarbonCopy,
    paramKey: 'cc_emails',
    outboundAccesor: buildEmailList
  },
  BlindCarbonCopy: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.BlindCarbonCopy,
    paramKey: 'bcc_emails',
    outboundAccesor: buildEmailList
  },
  Attachments: {
    key: 'attachments',
    paramKey: 'attachments',
    outboundAccesor: buildAttachments
  },
  Interviews: {
    key: 'interviews',
    paramKey: 'interviews',
    outboundAccesor: buildLegacyInterviews
  },
  EmailSubject: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.EmailSubject,
    paramKey: 'subject'
  },
  EmailBody: EMAIL_DETAILS_FORM_FIELDS_MAP.EmailBody,
  ResolvedEmailBody: EMAIL_DETAILS_FORM_FIELDS_MAP.ResolvedEmailBody
};

const SUBMISSION_EXCLUDED_FIELDS = [
  'InterviewType',
  'InterviewDate',
  'InterviewTimeFrame',
  'InterviewFromHour',
  'InterviewToHour',
  'InterviewTimezone',
  'InterviewAddress',
  'InterviewLink',
  'Interviews'
];

export const SENDOUT_SUBMISSION_FIELDS_MAP = omit(FORM_FIELDS_MAP, SUBMISSION_EXCLUDED_FIELDS);

export const CONFIRMATION_DIALOGS = {
  NoAttachments: 'noAttachments',
  Preview: 'preview',
  WithoutMailConfirmation: 'withoutMailConfirmation'
};
